import Box from '@mui/material/Box'
import { WidgetField } from '@tm/shared-lib/src/field'
import { useEffect, useRef } from 'react'

type WidgetFrameProps = {
  widgetId: string
}

function WidgetFrame(props: WidgetFrameProps) {
  const basePath = process.env.WIDGET_SCRIPT_URL || 'https://widget.trustmary.com/'

  const { widgetId } = props

  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const handleMessage = (event: MessageEvent<{ type: string; height: number }>) => {
      if (event.data?.type === 'tm-widget-height' && iframeRef.current) {
        iframeRef.current.style.height = `${event.data.height}px`
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  return (
    <Box
      component="iframe"
      ref={iframeRef}
      srcDoc={`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8">
            <style>
              * { margin: 0; padding: 0; box-sizing: border-box; }
              html, body { width: 100%; overflow: hidden; }
            </style>
            <script>
              // Prevent popups from tag
              window.hasTrustmaryPopupFromTag = true;

              function updateHeight() {
                window.parent.postMessage({
                  type: 'tm-widget-height',
                  height: document.documentElement.scrollHeight
                }, '*')
              }

              // Listen for resize events
              window.addEventListener('resize', updateHeight)

              // Create resize observer for content changes
              const resizeObserver = new ResizeObserver(updateHeight)
              document.addEventListener('DOMContentLoaded', () => {
                resizeObserver.observe(document.body)
              })

              // Handle external height check requests
              window.addEventListener('message', function(e) {
                if (e.data === 'tm-get-height') {
                  updateHeight()
                }
              })
            </script>
          </head>
          <body>
            <script src="${basePath}${widgetId}"></script>
          </body>
        </html>
      `}
      sx={{
        border: 'none',
        width: `calc(100% + ${8 * 3 * 2})`,
        height: '100px',
        m: {
          xs: -2,
          md: -3,
        },
        borderRadius: 1,
      }}
      title="Trustmary Widget"
    />
  )
}

export function WidgetInput(props: { field: WidgetField }) {
  const { widgetId } = props.field
  if (!widgetId) return null

  return <WidgetFrame widgetId={widgetId} />
}
